// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2b5c0a8f","239":"0a4633a2","453":"9757ffac","732":"a5c80ab5"}[chunkId] + ".chunk.js";
};